import { ProhibitIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Block = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <ProhibitIcon size={Sizes[size]} {...rest} color={fill} />;
};

Block.displayName = 'Block';
